import React from 'react';
export function RedoIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.714 7.306l-2.995-3A1 1 0 0016.3 5.713l1.29 1.3L8.508 7H8.5a5.5 5.5 0 10-.01 11l7.5.011a1 1 0 000-2l-7.496-.01a3.5 3.5 0 11.005-7l9.087.013L16.3 10.3a1 1 0 101.412 1.416l3-2.995a1 1 0 00.002-1.415z"
  }));
}